import empanada from './Recursos/empananda.svg'
import casa from './Recursos/casa.svg'
import feliz from './Recursos/carafeliz.svg'
import ic_insta_color from './Recursos/ic_inst_color.svg'
import ic_face_color from './Recursos/ic_face_color.svg'
import inst from './Recursos/ic_insta.svg'
import face from './Recursos/ic_face.svg'
import tiktok from './Recursos/ic_tiktok.svg'
import lajas1 from './Recursos/lajas1.png'
import lajas2 from './Recursos/lajas2.png'
import lajas3 from './Recursos/lajas3.png'
import lajas4 from './Recursos/lajas4.png'
import carrera62 from './Recursos/carrera62.png'
import carrera63 from './Recursos/carrera63.png'
import carrera64 from './Recursos/carrera64.png'
import once1 from './Recursos/once1.png'
import once2 from './Recursos/once2.png'
import once3 from './Recursos/once3.png'
import once4 from './Recursos/once4.png'
import once5 from './Recursos/once5.png'
import once6 from './Recursos/once6.png'
import puenes1 from './Recursos/puenes1.png'
import puenes2 from './Recursos/puenes2.png'
import puenes3 from './Recursos/puenes3.png'
import puenes4 from './Recursos/puenes4.png'
import tuquerres1 from './Recursos/tuquerres1.png'
import tuquerres2 from './Recursos/tuquerres2.png'
import hombre from './Recursos/Testimonios/hombre.png'
import mujer from './Recursos/Testimonios/mujer.png'
import enfermera from './Recursos/Testimonios/enfermera.png'
import estetica from "./Recursos/Escuelas/estetica.png";
import sistemas from "./Recursos/Escuelas/sistemas.png";
import salud from "./Recursos/Escuelas/salud.png";
import negocio from "./Recursos/Escuelas/negocio.png";
import arte from "./Recursos/Escuelas/arte.png";
import deporte from "./Recursos/Escuelas/deporte.png";
import infantil from "./Recursos/Escuelas/infantil.png";
import juridicas from "./Recursos/Escuelas/juridicas.png";
import veterianaria from "./Recursos/Escuelas/veterianaria.png";
import aduanas from "./Recursos/Escuelas/aduanas.png";
import turismo from "./Recursos/Escuelas/turismo.png";
import electricos from "./Recursos/Escuelas/eletricos.png";
import comida from "./Recursos/Escuelas/comida.png";
import ic_wass from "./Recursos/ic_wass.svg";
import ic_direccion from './Recursos/Iconos/ic_direccion.svg'
import ic_telefono from './Recursos/Iconos/ic_telefono.svg'
import ic_correo from './Recursos/Iconos/ic_correo.svg'
import ic_horario from './Recursos/Iconos/ic_horarios.svg'

export const SECCIONES = ['Inscripciones', 'Contactos', 'Testimonios']

export const NEGRITA = 'Bebas Neue'

export const CATEGORIAS = ['UNO', 'DOS', 'TRES']

export const WASS = '3172880347'

export const INDICADORES = [
    {
        nombre: 'Años en el mercado',
        img: empanada,
        numero: 14
    },
    {
        nombre: 'Clientes Satisfechos',
        img: feliz,
        numero: 3500
    },
    {
        nombre: 'Locales Fisicos',
        img: casa,
        numero: 5
    },
]

export const DIRECCIONLOCALES = [
    {
        direccion: 'Cra 6 #10-54',
        nombre: 'Carrera 6',
        descripcion: 'Visítanos en la Calle 6, la vía más importante de la ciudad. ¡Fácil de encontrar, imposible de olvidar!',
        celular: '3158518951',
        lat: 0.8239815309607968,
        long: -77.63649087635666,
        fotos: [carrera62, carrera63, carrera64],
        dias: 'Lunes a Sabado',
        horas: '8 Am a 8 Pm'
    },
    {
        direccion: 'Cra 11 #15-74',
        nombre: 'Carrera 11',
        descripcion: 'Nuestro local en la Calle 11 cuenta con espacio para estacionar, perfecto para disfrutar sin afanes. Ven en carro, quédate por el sabor.',
        celular: '3158518951',
        lat: 0.8242729310070137,
        long: -77.64239896517618,
        fotos: [once1, once2, once3, once4, once5, once6],
        dias: 'Lunes a Sabado',
        horas: '8 Am a 7 Pm'
    },
    {
        direccion: 'Cra 7 # 26-46',
        nombre: 'Puenes',
        descripcion: 'Estamos cerca del centro comercial más importante de la ciudad. Haz una pausa, ven por tu antojo y sigue disfrutando tu día.',
        celular: '3158142793',
        lat: 0.8284386112039551,
        long: -77.65280666866164,
        fotos: [puenes1, puenes2, puenes3, puenes4],
        dias: 'Domingo a Domingo',
        horas: 'L - S / 8am - 8pm',
        horasdos: 'D / 8am - 12am / 4pm a 8pm',
        size: 12
    },
    {
        direccion: 'Las Lajas - 30 mts del parqueadero',
        nombre: 'Las Lajas',
        descripcion: 'El sitio turístico más visitado de Ipiales. Disfruta lo mejor de Quesuditas antes o después de tu recorrido.',
        celular: '3172880347',
        lat: 0.8065385869104661,
        long: -77.58304459866552,
        fotos: [lajas1, lajas2, lajas3, lajas4],
        dias: 'Domingo a Domingo',
        horas: 'L-S / 7am - 12m / 3pm - 6pm',
        horasdos: 'D y Festivos / Jornada Continua',
        size: 12
    },
    {
        direccion: 'Calle 15 #14-44 Túquerres',
        nombre: 'Túquerres',
        descripcion: 'En esta tierra fría el verdadero calor está en lo que compartimos. Por eso preparamos nuestros platos con mucho amor para regalar calorcito al alma, convirtiendo cada bocado en un momento para disfrutar.',
        celular: '3152038243',
        lat: 1.08897,
        long: -77.61915,
        fotos: [tuquerres1, tuquerres2],
        dias: 'Domingo a Domingo',
        horas: 'L-V / 8:30am - 7pm Jornada Continua',
        horasdos: 'S Y D / 9am a 12:30pm y 2:30pm a 7pm',
        size: 12
    },
]

export const REDES = [
    {
        nombre: 'tiktok',
        imgColor: tiktok,
        img: tiktok,
        url: 'https://www.tiktok.com/@quesuditascafeteria'
    },
    {
        nombre: 'facebook',
        imgColor: ic_face_color,
        img: face,
        url: 'https://www.facebook.com/Quesuditas.Cafeteria'
    },
    {
        nombre: 'instagram',
        imgColor: ic_insta_color,
        img: inst,
        url: 'https://www.instagram.com/quesuditas.cafeteria/?hl=es'
    },
    {
        nombre: 'whatsapp',
        imgColor: ic_wass,
        img: ic_wass,
        url: 'https://www.instagram.com/quesuditas.cafeteria/?hl=es'
    },
]

export const CONTACTOS = [
    {
        nombre: 'Direccion',
        descripcion: 'Calle 16 # 24 - 48, Ipiales, Nariño.',
        icon: ic_direccion
    },
    {
        nombre: 'Línea Fija',
        descripcion: '(602) 773 3465',
        icon: ic_telefono
    },
    {
        nombre: 'WhatsApp / Celular',
        descripcion: '+57 315 515 9904',
        icon: ic_telefono
    },
    {
        nombre: 'Correo',
        descripcion: 'info@cessa.edu.co',
        icon: ic_correo
    },
    {
        nombre: 'Correo',
        descripcion: 'mercadeo@cessa.edu.co',
        icon: ic_correo
    },
    {
        nombre: 'Horarios',
        descripcion: 'Lunes a Sabado\n' +
            '8:00am - 6:00pm',
        icon: ic_horario
    },

]

export const TESTIMONIOS = [

    {
        nombre: 'Andrea Ruiz',
        curso: 'Técnico en Asistente Administrativo',
        descripcion: 'Gracias a CESSA, hoy apoyo la gestión operativa de una gran empresa con eficiencia y ética profesional',
        foto: mujer,
    },
    {
        nombre: 'Carlos Mera',
        curso: 'Técnico en Desarrollo de Software',
        descripcion: 'La formación práctica me permitió desarrollar soluciones de software reales y entrar rápido al sector tecnológico',
        foto: hombre,
    },
    {
        nombre: 'Elena Pantoja',
        curso: 'Técnico en Seguridad y Salud en el Trabajo',
        descripcion: 'Aprendí a prevenir riesgos y crear ambientes seguros. Mi formación en el SG-SST fue clave para mi empleo actual',
        foto: enfermera,
    },

]

export const OFERTAACADEMICA = [
    {
        nombre: 'Escuela de Estética y Bienestar Humano',
        items: [
            'Técnico laboral por competencias en cosmetología y estética integral',
            'Técnico laboral por competencias en estilista integral',
            'Técnico laboral por competencias en barbería'
        ],
        img: estetica
    },
    {
        nombre: 'Escuela de Sistemas y Tecnología',
        items: [
            'Técnico laboral por competencias en desarrollo de software',
            'Técnico laboral por competencias administrador en centro de datos',
            'Técnico laboral por competencias en diseñador web y multimedia'
        ],
        img: sistemas
    },
    {
        nombre: 'Escuela de Ciencias de la Salud',
        items: [
            'Técnico laboral por competencias en salud oral',
            'Técnico laboral por competencias en administrativo en salud',
            'Técnico laboral por competencias en enfermería',
            'Técnico laboral por competencias en auxiliar en salud publica',
            'Técnico laboral por competencias en servicios farmacéuticos'
        ],
        img: salud
    },
    {
        nombre: 'Escuela de Administración y Negocios',
        items: [
            'Técnico laboral por competencias en asistente administrativo',
            'Técnico laboral por competencias en gestión documental',
            'Técnico laboral por competencias auxiliar en banca y finanzas',
            'Técnico laboral por competencias costos y presupuestos',
            'Técnico Laboral por competencias en gestion integrada de la Calidad',
            'Técnico Laboral por competencias en seguridad y Salud en el trabajo',
            'Técnico Laboral por competencias en administración',
            'Técnico laboral por competencias en contabilidad y finanzas con énfasis en NIIF',
            'Técnico laboral por competencias en gestión de entidades bancarias y financieras',
            'Técnico laboral por competencias en organización de eventos',
            'Técnico laboral por competencias en gestión del talento Humano'
        ],
        img: negocio
    },
    {
        nombre: 'Escuela de Diseño y Arte',
        items: [
            'Técnico laboral por competencias diseño de modas',
            'Técnico laboral por competencias confección industrial en prendas de vestir',
            'Técnico laboral por competencias en diseño grafico'
        ],
        img: arte
    },
    {
        nombre: 'Escuela de Deporte y Actividad Física',
        items: [
            'Técnico laboral por competencias en entrenamiento deportivo'
        ],
        img: deporte
    },
    {
        nombre: 'Escuela de la Educación y Desarrollo Infantil',
        items: [
            'Técnico laboral por competencias atención en primera infancia'
        ],
        img: infantil
    },
    {
        nombre: 'Escuela de Ciencias Sociales y Jurídicas',
        items: [
            'Técnico laboral por competencias asistencia legal y jurídico'
        ],
        img: juridicas
    },
    {
        nombre: 'Escuela de Ciencias Agropecuarias y Veterinarias',
        items: [
            'Técnico laboral por competencias en asistente veterinario.'
        ],
        img: veterianaria
    },
    {
        nombre: 'Escuela de Logística y Comercio',
        items: [
            'Técnico laboral por competencias en logística de aduanas',
            'Técnico Laboral por competencias en auxiliar en Comercio exterior',
            'Técnico laboral por competencias en gestión logística'
        ],
        img: aduanas
    },
    {
        nombre: 'Escuela de Turismo y Servicios Aeroportuarios',
        items: [
            'Técnico laboral por competencias en agente de servicio aeroportuario',
            'Técnico laboral por competencias en guía turístico'
        ],
        img: turismo
    },
    {
        nombre: 'Escuela de Industria y Mantenimiento',
        items: [
            'Técnico laboral por competencias en supervisión de redes de distribución de energía eléctrica',
            'Técnico laboral por competencias en electricidad',
            'Técnico laboral por competencias en mantenimiento de redes de gas',
            'Técnico laboral por competencias en desarrollo de sistemas electrónicos industriales',
            'Técnico laboral por competencias en mantenimiento de planta de abastecimiento de agua'
        ],
        img: electricos
    },
    {
        nombre: 'Escuela de Gastronomía y Artes Culinarias',
        items: [
            'Técnico laboral por competencias en procesos gastronómicos',
            'Técnico laboral por competencias en asistente en servicio social y comunitario'
        ],
        img: comida
    }
]